// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Priorities_RemoverResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * Response contract for POST /so/priorities/remover
 *
 * Wire shape preserved from legacy: `dados: null` — the endpoint signals
 * success purely via the envelope `success` flag and carries no payload.
 */
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export type Priorities_RemoverResponseDados = null;

export type Priorities_RemoverResponse = ApiResponse<Priorities_RemoverResponseDados>;

registerResponseContract('Priorities_RemoverResponse', {})
